/* eslint-disable react-hooks/exhaustive-deps */
import useFetch from '@hooks/useFetch';

const useGoalFAQs = (options = { selector: null, fallbackData: undefined }) => {
  const key = 'v1/faq/?type=2';
  const {
    data: faqs,
    isValidating,
    ...rest
  } = useFetch(
    key,
    { useCamelCase: false },
    { fallbackData: options.fallbackData }
  );

  if (options.selector && typeof options.selector === 'function')
    return options.selector(faqs || {});
  return {
    key,
    faqs,
    isValidating,
    ...rest
  };
};

export default useGoalFAQs;
